import BaseService from "../core/base-service";
import StorageService from "../core/storage-service";

export default class ActivityService extends BaseService {
  // TODO: change this to your route in server
  static route = "activity";
  private storage: StorageService = new StorageService();

  async getNoticeData(pageNo = 1,category: string) {
    const url = `/api/patent/movement?page=${pageNo}&size=10`;
    const response = await this.httpService.post<any, any>(url, {page: pageNo, size: 10, category: category,year: "2024"});
    return response;
  }

  /* 获取报名详情 */
  async getWorksDetail() {
    const url = `/api/c/patent/hlj/detail`;
    const response = await this.httpService.get<any>(`${url}?year=2025`);
    return response;
  }
}
